const path = require('path');
const version = require('./public/version.json');
function resolve(dir) {
  return path.join(__dirname, dir)
};
//console.log(`******************will be uploaded here: http://s.resn.info/kar/${version.build}/index.html`);
//console.log(`******************will be uploaded here: http://s.resn.info/kar/${version.build}/index.html`);
//console.log(`******************will be uploaded here: http://s.resn.info/kar/${version.build}/index.html`);

//const conf = require('./conf.json')

// const CompressionWebpackPlugin = require('compression-webpack-plugin')
// const productionGzipExtensions = ['js', 'css']
// let plugins = []
// if (process.env.NODE_ENV === 'production') {
//   plugins.push(
//     new CompressionWebpackPlugin({
//       algorithm: 'gzip',
//       test: new RegExp('\\.(' + productionGzipExtensions.join('|') + ')$'),
//       threshold: 10240,
//       minRatio: 0.8,
//     })
//   )
// }

module.exports = {
  //baseUrl: `/kar/${version.build}/`,
  baseUrl: `/`,
  outputDir: `dist/${version.build}`,
  pluginOptions: {
    i18n: {
      locale: 'en',
      fallbackLocale: 'en',
      localeDir: 'locales',
      enableInSFC: true,
    },
  },
  pages: {
    // index: {
    //   // entry for the page
    //   entry: 'src/index/main.js',
    //   // the source template
    //
    //   // output as dist/index.html
    //   filename: 'index.html',
    //   // when using title option,
    //   // template title tag needs to be <title><%= htmlWebpackPlugin.options.title %></title>
    //   title: 'Index Page',
    //   // chunks to include on this page, by default includes
    //   // extracted common chunks and vendor chunks.
    //   chunks: ['chunk-vendors', 'chunk-common', 'index']
    // }
    app: {
      entry: 'src/index.js',
      template: 'public/index.html',
      filename: 'index.html',
      chunks: ['chunk-vendors', 'chunk-common', 'app'],
    },
  },
  configureWebpack: () => {
    return {
      resolve: {
        alias: {
          src: resolve('src'),
          assets: resolve('src/assets'),
        },
      },
      //plugins: plugins
    }
  },
  chainWebpack: (config) => {
    // remove the prefetch plugin
    // config.plugins.delete('prefetch-app')

    if (process.env.NODE_ENV === 'development') {
      // prettier-ignore
      config
        .output
        .filename('[name].[hash].js')
        .end()
    }

    config.module
      .rule('3d')
      .test(/\.(dae|obj|collada|mtl|jd|txt)$/)
      .use('file')
      .loader('file-loader')
      .options({
        name: 'models/[name].[hash:7].[ext]',
      })
      .end();
    config.module
      .rule('spine')
      .test(/\.(atlas)$/)
      .use('file')
      .loader('file-loader')
      .options({
        name: 'models/[name].[hash:7].[ext]',
      })
      .end();

    config.module
      .rule('glsl')
      .test(/\.(glsl|frag|vert)$/)
      .use('webpack-glsl')
      .loader('webpack-glsl-loader')
      .end();

    config.module
      .rule('worker')
      .test(/\.worker\.js$/)
      .use('worker')
      .loader('worker-loader')
      .options({
        name: 'js/[name].[hash:7].[ext]',
      })
      .end();

    // config.module
    //   .rule('font-subset')
    //   .test(/\.subset.ttf$/)
    //   .use('font-subset')
    //   .loader('font-subset-loader')
    //   .options({
    //     glyphs: require('./src/i18n/messagesFlat.js'),
    //   })
    //   .end()
  },
};
